import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { UsersTableDefinitionZod } from '../tables';

type Arguments = {
    userId: string;
};

export const schemaUserResolver_GetUserNameById = UsersTableDefinitionZod.pick({
    firstName: true,
    gender: true,
    id: true,
    lastName: true,
}).nullable();

export type SchemaUserResolver_GetUserNameById = z.infer<typeof schemaUserResolver_GetUserNameById>;

export type UserResolver_GetUserNameById = Resolver<Arguments, SchemaUserResolver_GetUserNameById>;
